import { put, call, takeLatest } from "redux-saga/effects";
import { cycleReportConstants } from "../../constants";
import { callAPI } from "../commonApiCall";
import apiURLs from "../../config/url-config";
import { cycleReport, alertActions } from "../../actions";
import { get } from "lodash";

function* cycleReportListing(action) {
  try {
    const is_download = get(action, "payload.is_download", false);

    const data = yield call(
      callAPI,
      apiURLs.cycleReportUrl.list,
      action.payload
    );

    if (data.status === true) {
      yield put(
        cycleReport.cycleReportListingSuccess({
          list: data.data && data.data.list
        })
      );
    } else if (is_download) {
      yield put(cycleReport.cycleReportDownloadSuccess());
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
    console.log("=====error", error);
  }
}

export function* cycleReportSaga() {
  yield takeLatest(
    cycleReportConstants.CYCLE_REPORT_LISTING_REQUEST,
    cycleReportListing
  );
  yield takeLatest(
    cycleReportConstants.CYCLE_REPORT_DOWNLOAD_REQUEST,
    cycleReportListing
  );
}
